import React, { useState, useEffect } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import Overlay from '../../Components/Overlay/Overlay';
import { uploadAsset, getAssetById, updateAsset } from '../../Services/AssetService';
import { getMetas } from '../../Services/MetaService';
import { getLimitById } from '../../Services/LimitService';
import { getMenus } from '../../Services/MenuService';
import { getTypes, getExtension } from '../../Services/TypeService';
import { getFilters } from '../../Services/FilterService';
import { handlerFormError } from '../../Utils/Utils';
import { Uploader } from 'rsuite';
import 'rsuite/dist/rsuite.min.css'
import { useSelector } from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useUploadForm } from '../../Services/AssetUploadService'

const { $ } = window;
let procesingId = -1;

const AssetDetailScreen = () => {
    const { pageState, id } = useParams();
    const { userInfo } = useSelector(state => state.auth);

    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({
        defaultValues: {
            title: '',
            description: '',
            hastag: '',
            asset_month: '',
            asset_year: '',
            type_id: '',
            function_id: '',
            category_id: '',
            brand: '',
            filter_id: ''
        }
    });

    const [checked, setChecked] = useState(false);
    const [checkedFile, setCheckedFile] = useState(true);
    const [checkedTrash, setCheckedTrash] = useState(true);
    const [isnotvalid, setIsNotValid] = useState(false);

    const [state, setState] = useState({
        asset: { type: { _id: -1 }, category: { _id: -1 }, filter: { _id: -1 }, function: { _id: -1} },
        types: [],
        extensions: [],
        filters: [],
        main_menus: [],
        sub_menus: [],
        brands: [],
        thumbnail: '',
        preview_url: '',
        menu_num: 0,
        std_file_size: 0,
        high_file_size: 0,
        low_file_size: 0,
        raw_file_size: 0,
        highMaxUpload: 5,
        lowMaxUpload: 5,
        rawMaxUpload: 2,
        stdMaxUpload: 5,
        limit: {},
        meta: {},
        years: [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        processing: false,
        formats: [
            'header',
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'list', 'bullet', 'indent',
            'link', 'image'
        ],
        modules: {
            toolbar: [
              [{ 'header': [1, 2, false] }],
              ['bold', 'italic', 'underline','strike', 'blockquote'],
              [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
              ['link', 'image'],
              ['clean']
            ],
        },
        singleFileList: [],
        singleFileObj: [],
        highFileList: [],
        highFileObj: [],
        lowFileList: [],
        lowFileObj: [],
        rawFileList: [],
        rawFileObj: [],
        delStdFileList: [],
        delHigFileList: [],
        delLowFileList: [],
        delRawFileList: [],
    });

    const { isSuccess, uploadForm, progress } = useUploadForm();
    const [editorHtmlValue, setEditorHtmlValue] = useState("");
    const handleContentChange = (content, delta, source, editor) => {
        setEditorHtmlValue(content);
        setValue('description', content)
        // let has_attribues = delta.ops[1].attributes || "";
        //const cursorPosition = e.quill.getSelection().index;
        //this.quill.insertText(cursorPosition, "★");
        //this.quill.setSelection(cursorPosition + 1);
    };
    const setChange = (e) => {
        if (e.target.name === 'function_id') {
            getMenus({ perpage: 100, filter: `parent._id:${(e.target.value)}`, order: `sort`, direction: `asc` }).then((res) => {
                setState({ ...state, menu_num: e.target.value, sub_menus: res.data.data, brands: [] });
            });
        } else if (e.target.name === 'category_id') {
            getMenus({ perpage: 100, filter: `parent._id:${(e.target.value)}`, order: `sort`, direction: `asc` }).then((res) => {
                setState({ ...state, brands: ['Modena', 'Mologiz', 'Prive', 'Ambiente', 'MKS', 'Culinaria'] });
            });
        } else if (e.target.name === 'type_id') {
            const { singleFileList, highFileList, lowFileList, rawFileList } = state;
            let sUpload = 5; let hUpload = 5; let lUpload = 5; let rUpload = 2; 
            let delStd = []; let delHigh = []; let delLow = []; let delRow = []
            
            if(e.target.value == 3){
                sUpload = 1; hUpload = 1; lUpload = 1; rUpload = 1;
            }

            singleFileList.map(item => {
                if(item.url !== '')
                    delStd.push(item)    
            })

            highFileList.map(item => {
                if(item.url !== '')
                    delHigh.push(item)
            })
            
            lowFileList.map(item => {
                if(item.url !== '')
                    delLow.push(item)    
            })

            rawFileList.map(item => {
                if(item.url !== '')
                    delRow.pop(item)    
            })

            getExtension({ 'id': 'dot', 'code': e.target.value }).then(res => {
                setState({ 
                    ...state, 
                    extensions: res.data.data, 
                    highMaxUpload: hUpload, 
                    lowMaxUpload: lUpload, 
                    rawMaxUpload: rUpload, 
                    stdMaxUpload: sUpload, 
                    singleFileObj: [], 
                    highFileObj: [],
                    lowFileObj: [],
                    rawFileObj: [],
                    singleFileList: delStd, 
                    highFileList: delHigh, 
                    lowFileList: delLow, 
                    rawFileList: delRow
                })
            });
        }
    }

    const thumbnailUpload = e => {
        if (e.length > 0) {
            if(e[0].blobFile.size >= 750000 ){ //size in Byte = 750kb
                Swal.fire({
                    icon: 'error',
                    title: 'Save data failed!',
                    text: 'Thumbnail size exceed limit max 750Kb, [uploaded size is : '+ parseFloat(e[0].blobFile.size / 1000).toFixed(0) +'Kb] Pls remove manually'
                }).then(r => {
                    setState({ ...state, thumbnail: ''});
                    setIsNotValid(true);
                })
            }else if (e[0].blobFile.type.toString() != 'image/png' && e[0].blobFile.type.toString() != 'image/gif'  && e[0].blobFile.type.toString() != 'image/jpg' && e[0].blobFile.type.toString() != 'image/jpeg'){
                Swal.fire({
                    icon: 'error',
                    title: 'Save data failed!',
                    text: 'Thumbnail file type must png/gif/jpg/jpeg, Pls remove manually' 
                }).then(r => {
                    setState({ ...state, thumbnail: ''});
                    setIsNotValid(true);
                })
            }else{
                setState({ ...state, thumbnail: e[0].blobFile});
                setIsNotValid(false);
            }
        }
    }

    const thumbnailRemove = e => {
        setState({ ...state, thumbnail: '' });
        setIsNotValid(false);
    }

    const fileUpload = e => {
        if (e.length > 0) {
            let fSingle = [];
            let sObj  = [];
            let size = 0;
            let ext = true;
            e.map(item => {
                if(item.hasOwnProperty('blobFile')){
                    ext = cekExtension(item.blobFile.name, item.blobFile.size, e.length, 'std')
                    if(ext){
                        sObj.push(item.blobFile);
                        size = size + item.blobFile.size;
                        fSingle.push({name: item.name, fileKey: item.fileKey, url: item?.url || ''})
                    } else {
                        e.pop(item)
                    }
                }else{
                    fSingle.push({name: item.name, fileKey: item.fileKey, url: item?.url || ''})
                }
            });

            setState({ ...state, singleFileList: fSingle, singleFileObj: sObj, std_file_size: size });
            setTimeout(() => {
                chechStorage('standard', size);
            }, 150);
        }
    }

    const fileRemove = e => {
        let size = 0;
        const { singleFileObj, singleFileList, delStdFileList } = state
        let objList = singleFileObj; let stdFlist = singleFileList; let delList = delStdFileList;
        stdFlist.splice(stdFlist.findIndex(item => item.fileKey === e.fileKey), 1)
        objList.splice(objList.findIndex(item => item.fileKey === e.fileKey), 1)
        objList.map(item => {
            size = size + item?.blobFile?.size || 0;
        }); 

        if((e.url !== undefined)){
            delList.push({ name: e.url });
        }

        setState({ ...state, std_file_size: size, singleFileObj: objList, singleFileList: stdFlist, delStdFileList: delList });
        setIsNotValid(false);
    }

    const highUpload = e => {
        if (e.length > 0) {
            let fHigh = [];
            let sObj  = [];
            let size = 0;
            let ext = true;
            e.map(item => {
                if(item.hasOwnProperty('blobFile')){
                    ext = cekExtension(item.blobFile.name, item.blobFile.size, e.length, 'high')
                    if(ext){
                        sObj.push(item.blobFile);
                        size = size + item.blobFile.size;
                        fHigh.push({name: item.name, fileKey: item.fileKey, url: item?.url || ''})
                    } else {
                        e.pop(item)
                    }
                } else {
                    fHigh.push({name: item.name, fileKey: item.fileKey, url: item?.url || ''})
                }
            });

            setState({ ...state, highFileList: fHigh, highFileObj: sObj, high_file_size: size });

            setTimeout(() => {
                chechStorage('high', size);
            }, 150);
        }
    }

    const highRemove = e => {
        let size = 0;
        const { highFileObj, highFileList, delHigFileList } = state
        let objList = highFileObj; let highFlist = highFileList; let delList = delHigFileList;
        highFlist.splice(highFlist.findIndex(item => item.fileKey === e.fileKey), 1)
        objList.splice(objList.findIndex(item => item.fileKey === e.fileKey), 1)
        objList.map(item => {
            size = size + item?.blobFile?.size || 0;
        });

        if((e.url !== undefined)){
            delList.push({ name: e.url });
        }

        setState({ ...state, high_file_size: size, highFileObj: objList, highFileList: highFlist, delHigFileList: delList });
        setIsNotValid(false);
    }

    const lowUpload = e => {
        if (e.length > 0) {
            let fLow = [];
            let sObj  = [];
            let size = 0;
            let ext = true;
            e.map((item, i) => {
                if(item.hasOwnProperty('blobFile')){
                    ext = cekExtension(item.blobFile.name, item.blobFile.size, e.length, 'low')
                    if(ext){
                        sObj.push(item.blobFile);
                        size = size + item.blobFile.size;
                        fLow.push({name: item.name, fileKey: item.fileKey, url: item?.url || ''})
                    } else {
                        e.pop(item)    
                    }
                }else{
                    fLow.push({name: item.name, fileKey: item.fileKey, url: item?.url || ''})
                }
                
            });

            setState({ ...state, lowFileList: fLow, lowFileObj: sObj, low_file_size: size });
            setTimeout(() => {
                chechStorage('low', size);
            }, 150);
        }
    }

    const lowRemove = e => {
        let size = 0;
        const { lowFileObj, lowFileList, delLowFileList } = state
        let objList = lowFileObj; let lowFList = lowFileList; let delList = delLowFileList
        lowFList.splice(lowFList.findIndex(item => item.fileKey === e.fileKey), 1)
        objList.splice(objList.findIndex(item => item.fileKey === e.fileKey), 1)
        objList.map(item => {
            size = size + item?.blobFile?.size || 0;
        });

        if((e.url !== undefined)){
            delList.push({ name: e.url });
        }

        setState({ ...state, low_file_size: size, lowFileObj: objList, lowFileList: lowFList, delLowFileList: delList });
        setIsNotValid(false);
    }

    const rawUpload = e => {
        if (e.length > 0) {
            let fRaw = [];
            let sObj  = [];
            let size = 0;
            let ext = true;
            e.map((item, i) => {
                if(item.hasOwnProperty('blobFile')){
                    ext = cekExtension(item.blobFile.name, item.blobFile.size, e.length, 'raw');
                    if(ext){
                        sObj.push(item.blobFile);
                        size = size + item.blobFile.size;
                        fRaw.push({name: item.name, fileKey: item.fileKey, url: item?.url || ''})
                    }else{
                        e.pop(item)
                    }
                }else{
                    fRaw.push({name: item.name, fileKey: item.fileKey, url: item?.url || ''})
                }
            });

            setState({ ...state, rawFileList: fRaw, rawFileObj: sObj, raw_file_size: size });
            setTimeout(() => {
                chechStorage('raw', size);
            }, 150);
        }
    }

    const rawRemove = e => {
        let size = 0;
        const { rawFileObj, rawFileList, delRawFileList } = state
        let objList = rawFileObj; let rawFList = rawFileList; let delList = delRawFileList
        rawFList.splice(rawFList.findIndex(item => item.fileKey === e.fileKey), 1)
        objList.splice(objList.findIndex(item => item.fileKey === e.fileKey), 1)
        objList.map(item => {
            size = size + item?.blobFile?.size || 0;
        });

        if((e.url !== undefined)){
            delList.push({ name: e.url });
        }

        setState({ ...state, raw_file_size: size, rawFileObj: objList, rawFileList: rawFList, delRawFileList: delList });
        setIsNotValid(false);
    }

    const cekExtension = (param, size, length, type ) => {
        const { extensions, stdMaxUpload, highMaxUpload, lowMaxUpload, rawMaxUpload } = state;
        var _validFileExtensions = extensions;
        var sFileName = param;
        if (sFileName.length > 0) {
            var blnValid = false;
            for (var j = 0; j < _validFileExtensions.length; j++) {
                var sCurExtension = extensions[j];
                if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                    blnValid = true;
                    break;
                }
            }
                
            if (!blnValid) {
                Swal.fire({
                    icon: 'error',
                    title: 'Upload data failed!',
                    text: "Sorry, " + sFileName + " is invalid, allowed extensions are: " + _validFileExtensions.join(", ")
                }).then()
                return false;
            }

            switch(type){
                case 'high':
                    if(size >= 50000000 ){ //size in Byte = 50MB
                        Swal.fire({
                            icon: 'error',
                            title: 'Save data failed!',
                            text: 'Thumbnail size exceed limit max 50MB, [uploaded size is : '+ parseFloat(size / 1000).toFixed(0) +'Kb] Pls remove manually'
                        }).then()
                        return false 
                    }

                    if( length > highMaxUpload){
                        Swal.fire({
                            icon: 'error',
                            title: 'Upload data failed!',
                            text: `Sorry, The number of files that can be uploaded is only ${highMaxUpload} `
                        }).then()
                        return false    
                    }
                    break;
                case 'low':
                    if( length > lowMaxUpload){
                        if(size >= 3000000 ){ //size in Byte = 3MB
                            Swal.fire({
                                icon: 'error',
                                title: 'Save data failed!',
                                text: 'Thumbnail size exceed limit max 3MB, [uploaded size is : '+ parseFloat(size / 1000).toFixed(0) +'Kb] Pls remove manually'
                            }).then()
                            return false 
                        }

                        Swal.fire({
                            icon: 'error',
                            title: 'Upload data failed!',
                            text: `Sorry, The number of files that can be uploaded is only ${lowMaxUpload} `
                        }).then()
                        return false    
                    }
                    break;
                case 'raw':
                    if( length > rawMaxUpload){
                        Swal.fire({
                            icon: 'error',
                            title: 'Upload data failed!',
                            text: `Sorry, The number of files that can be uploaded is only ${rawMaxUpload} `
                        }).then()
                        return false    
                    }
                    break;
                default:
                    if( length > stdMaxUpload){
                        Swal.fire({
                            icon: 'error',
                            title: 'Upload data failed!',
                            text: `Sorry, The number of files that can be uploaded is only ${rawMaxUpload} `
                        }).then()
                        return false    
                    }
                    break;
            }
        }
        
        return true;
    }

    const chechStorage = (param, size) => {
        const { high_file_size, low_file_size, raw_file_size, menu_num, limit, singleFileList, highFileList, lowFileList, rawFileList } = state;
        let total_upload = 0
        switch(param){
            case 'high':
                total_upload = ((size + low_file_size + raw_file_size) / 1000000000).toPrecision(3);
                break;
            case 'low':
                total_upload = ((high_file_size + size + raw_file_size) / 1000000000).toPrecision(3);
                break;
            case 'raw':
                total_upload = ((high_file_size + low_file_size + size) / 1000000000).toPrecision(3);
                break;
            case 'standard':
                total_upload = (size / 1000000000).toPrecision(3);
                break;
            default:
                total_upload = ((high_file_size + low_file_size + raw_file_size) / 1000000000).toPrecision(3);
                break;
        }
        
        let storage_free = 0;
        limit.bucket_used?.map(item => {
            if(menu_num == item.id){
                storage_free = item.free;
            }
        });

        if(storage_free < total_upload){
            Swal.fire({
                icon: 'error',
                title: 'Save data failed!',
                text: 'Incufuent Storage limit Free space : '+ storage_free +', Upload size is : '+ total_upload +' Pls resize file manually'
            }).then(r => {setIsNotValid(true);})
        }
    }

    const handleChange = () => {
        setChecked(!checked);
    };

    const handleChangeFile = () => {
        setCheckedFile(!checkedFile);
    };

    const handleChangeTrash = () => {
        setCheckedTrash(!checkedTrash);
    };

    const navigate = useNavigate();

    const onBack = () => { navigate(-1); }

    const startProcessing = () => {
        procesingId = setTimeout(() => {
            setState({ ...state, processing: true });
        }, 150);
    }

    const stopProcessing = () => {
        clearInterval(procesingId);
        setState({ ...state, processing: false });
    }

    const onSubmit = (data) => {
        const { singleFileList, singleFileObj, highFileList, delStdFileList, delHigFileList, delLowFileList, delRawFileList, highFileObj, lowFileList, lowFileObj, rawFileList, rawFileObj } = state;
        const formData = new FormData();

        for (var key in data) {
            formData.append(key, data[key]);
        }

        formData.append('file_thumbnail', thumbnail);
        formData.append('objectAccess', 'AclPrivate');

        if (pageState.toLowerCase() == 'edit') {
            formData.append('_method', 'put');
        }

        if (checkedFile) {formData.append('is_active_file', 1);} else {formData.append('is_active_file', 0);}
        if (checkedTrash) {formData.append('is_archive_trash', 1);} else {formData.append('is_archive_trash', 0);}

        if (!checked) {
            highFileObj.map((item, i) => {
                formData.append(`file_high[${i}]`, item);    
            })

            lowFileObj.map((item, i) => {
                formData.append(`file_low[${i}]`, item);    
            })

            rawFileObj.map((item, i) => {
                formData.append(`file_raw[${i}]`, item);    
            })

            formData.append('is_single', 0);
            formData.append('file_high_list', JSON.stringify(highFileList));
            formData.append('file_low_list', JSON.stringify(lowFileList));
            formData.append('file_raw_list', JSON.stringify(rawFileList));
            formData.append('file_high_del', JSON.stringify(delHigFileList));
            formData.append('file_low_del', JSON.stringify(delLowFileList));
            formData.append('file_raw_del', JSON.stringify(delRawFileList));

        } else {
            formData.append('is_single', 1);
            singleFileObj.map((item, i) => {
                formData.append(`file_single[${i}]`, item);    
            })

            formData.append('file_single_list', JSON.stringify(singleFileList));
            formData.append('file_single_del', JSON.stringify(delStdFileList));
        }
        startProcessing();
        //const response = pageState.toLowerCase() == 'add' ? uploadAsset(formData) : updateAsset(id, formData);
        const url = pageState.toLowerCase() == 'add' ? `api/v1/admin/asset` : `api/v1/admin/asset/${id}`;
        const response = uploadForm(url, formData);
        response.then(res => {
            if (res.status == 200 || res.status == 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Save data success',
                    text: 'Data has been saved!'
                }).then(r => {
                    onBack();
                })
            }
        }).catch(({ response: { data } }) => {
            handlerFormError(data);
        }).finally(_ => stopProcessing());
    }

    const onReset = () => {
        setChecked(false);
        setCheckedFile(true);
        setCheckedTrash(true);
        setState({
            ...state,
            asset: { _id: -1 },
            thumbnail: '',
            menu_num: 0,
            years: [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027],
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            processing: false,
            singleFileList: [],
            singleFileObj: [],
            highFileList: [],
            highFileObj: [],
            lowFileList: [],
            lowFileObj: [],
            rawFileList: [],
            rawFileObj: []
        })

        reset({
            title: '',
            description: '',
            hastag: '',
            asset_month: '',
            asset_year: '',
            type_id: '',
            function_id: '',
            category_id: '',
            brand: '',
            filter_id: '',
            std_file_size: 0,
            high_file_size: 0,
            low_file_size: 0,
            raw_file_size: 0,
            menu_num: 0
        });
    }

    useEffect(() => {
        const requests = [
            getTypes({ perpage: 50, filter: `is_active:true`, order: `type_code`, direction: `asc`  }).then(res => res.data.data),
            getFilters({ perpage: 50, filter: `is_active:true`, order: `filter_name`, direction: `asc`  }).then(res => res.data.data),
            getMenus({ perpage: 50, filter: `menu_level:1,is_active:true`, order: `sort`, direction: `asc` }).then(res => res.data.data),
            getExtension({ 'id': 'dot', 'code': '' }).then(res => res.data.data),
            getLimitById(1).then(res => res.data),
            getMetas({ perpage: 10, select: `meta_table`, filter: `meta:storage_period,is_active:true`, order: `sort`, direction: `asc` }).then(res => res.data.data),
        ];
        switch (pageState) {
            case 'add':
                Promise.all(requests).then(results => {
                    const [ _types, _filters, _menus, _extensions, _limit, _meta ] = results;
                    setState({
                        ...state,
                        types: _types,
                        filters: _filters,
                        main_menus : _menus,
                        extensions: _extensions,
                        limit: _limit,
                        meta: _meta[0]
                    });
                });

                break;
            case 'edit':
            case 'view':
                requests.push(
                    getAssetById(id)
                        .then(res => res.data)
                        .catch(({ response: { data: { message } } }) => {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error when getting user',
                                text: message
                            }).then(() => { navigate(-1) });
                        })
                );

                Promise.all(requests).then(results => {
                    const [_types, _filters, _menus, _extensions, _limit, _meta, _asset] = results;
                    let fSingle = [];
                    let fHigh = [];
                    let fLow = [];
                    let fRaw = [];
                    let files = _asset?.file;
                    Object.keys(files).map((key, i) => {
                        switch(key){
                            case 'high':
                                if(Array.isArray(files[key])){
                                    files[key].map((item, j) => 
                                        fHigh.push({name: item?.original_name || '-', fileKey: j, url: item?.preview_url || '-'})    
                                    )
                                }else{
                                    fHigh.push({name: files[key]?.original_name || '-', fileKey: i, url: files[key].preview_url})
                                }
                                break;
                            case 'low':
                                if(Array.isArray(files[key])){
                                    files[key].map((item, j) => 
                                        fLow.push({name: item?.original_name || '-', fileKey: j, url: item?.preview_url || '-'})    
                                    )
                                }else{
                                    fLow.push({name: files[key]?.original_name || '-', fileKey: i, url: files[key].preview_url})
                                }
                                break;
                            case 'raw':
                                if(Array.isArray(files[key])){
                                    files[key].map((item, j) => 
                                        fRaw.push({name: item?.original_name || '-', fileKey: j, url: item?.preview_url || '-'})    
                                    )
                                }else{
                                    fRaw.push({name: files[key]?.original_name || '-', fileKey: i, url: files[key].preview_url})
                                }
                                break;
                            default: //std
                                if(Array.isArray(files[key])){
                                    files[key].map((item, j) => 
                                        fSingle.push({name: item?.original_name || '-', fileKey: j, url: item?.preview_url || '-'})    
                                    )
                                }else{
                                    fSingle.push({name: files[key]?.original_name || '-', fileKey: i, url: files[key].preview_url})
                                }
                                break;
                        }
                    })

                    getExtension({ 'id': 'dot', 'code': _asset.type._id }).then(res => {
                        let sUpload = 5; let hUpload = 5; let lUpload = 5; let rUpload = 2; 
                        if(_asset.type._id == 3){
                            sUpload = 1; hUpload = 1; lUpload = 1; rUpload = 1;
                        }

                        setState({
                            ...state,
                            types: _types,
                            filters: _filters,
                            main_menus : _menus,
                            extensions: res.data.data,
                            limit: _limit,
                            asset: _asset,
                            preview_url: process.env.REACT_APP_OBS_URL +_asset.thumbnail?.preview_url,
                            menu_num: _asset.function._id,
                            meta: _meta[0],
                            singleFileList: fSingle,
                            highFileList: fHigh,
                            lowFileList: fLow,
                            rawFileList: fRaw,
                            highMaxUpload: hUpload, 
                            lowMaxUpload: lUpload, 
                            rawMaxUpload: rUpload, 
                            stdMaxUpload: sUpload
                        });
                        
                        setChecked(_asset.is_single);
                        setCheckedFile(_asset.is_active_file);
                        setCheckedTrash(_asset.is_archive_trash);
                        setEditorHtmlValue(_asset.description);
    
                        reset(_asset);
    
                        setValue('filter_id', _asset.filter._id);
                        setValue('type_id', _asset.type._id);
                        setValue('type_name', _asset.type.type_name);
                        setValue('function_id', _asset.function._id );
                        setValue('function_name', _asset.function.function_name);
                        setValue('category_id', _asset.category._id);
                        setValue('category_name', _asset.category.category_name);
                        setValue('brand', _asset.brand);
                    });
                });
                break;
            default:
                break;
        }

    }, []);

    const { processing, types, filters, thumbnail, singleFileList, highFileList, lowFileList, rawFileList, years, months, main_menus, sub_menus, brands, preview_url, meta, highMaxUpload, lowMaxUpload, rawMaxUpload, stdMaxUpload } = state;

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-left">
                                <li className="breadcrumb-item"><NavLink to="/home">Home</NavLink></li>
                                <li className="breadcrumb-item"><NavLink to="/asset">Asset</NavLink></li>
                                <li className="breadcrumb-item active">{pageState && pageState.charAt(0).toUpperCase() + pageState.slice(1)} Asset</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className='col-md-12'>
                            <div className='card'>
                                <Overlay display={processing} progress={progress} />
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className='card-header' style={{ height: 41}}>
                                        <div className='card-title'><i className='fa fa-user-tag' /> {pageState && pageState.charAt(0).toUpperCase() + pageState.slice(1)} Asset </div>
                                    </div>
                                    <div className='card-body'>
                                        <div className="row justify-content-md-center">
                                            <div className="col-8" style={{ marginBottom: `15px`}}>
                                                <label htmlFor="type_code">Fields with <span className='mandatory'></span> are required.</label>
                                            </div>
                                            <div className="col-8">
                                                <div className="row mb-3">
                                                    <label htmlFor="title" className="col-sm-2 col-form-label mandatory">Title</label>
                                                    <div className="col-sm-10">
                                                        <input id="title" {...register("title", { required: 'Title is required!' })} className='form-control' readOnly={pageState == 'view'} placeholder="Asset title.." />
                                                        {errors.title && <span className='text-danger'>{errors.title.message}</span>}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="description" className="col-sm-2 col-form-label mandatory">Description</label>
                                                    <div className="col-sm-10">
                                                        <ReactQuill theme="snow" formats={state.formats} modules={state.modules} rows={5} className='form-control' readOnly={pageState == 'view'} placeholder="Asset description.." value={editorHtmlValue} onChange={handleContentChange} />
                                                        {/* <textarea id="description" {...register("description", { required: 'Description is required!' })} className='form-control' readOnly={pageState == 'view'} value={editorHtmlValue} placeholder="Asset description.." /> */}
                                                        <input type='hidden' id="description" {...register("description", { required: 'Description is required!' })} value={editorHtmlValue} />
                                                        {errors.description && <span className='text-danger'>{errors.description.message}</span>}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="hastag" className="col-sm-2 col-form-label" style={{ paddingLeft: '24px' }}>Hastag</label>
                                                    <div className="col-sm-10">
                                                        <input id="hastag" {...register("hastag")} className='form-control' readOnly={pageState == 'view'} placeholder="Hastag (#photo, #icons) .." />
                                                        {errors.hastag && <span className='text-danger'>{errors.hastag.message}</span>}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="asset_month" className="col-sm-2 col-form-label mandatory">Month</label>
                                                    <div className="col-sm-10">
                                                        <select id="asset_month" className='form-control' {...register("asset_month", { required: 'Asset month is required!' })}>
                                                            <option value="-1" >-- Select Month --</option>
                                                            {months.map((item, i) => <option key={`asset-month-${i}`} value={item} >{item}</option>)}
                                                        </select>
                                                        {errors.asset_month && <span className='text-danger'>{errors.asset_month.message}</span>}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="asset_year" className="col-sm-2 col-form-label mandatory">Year</label>
                                                    <div className="col-sm-10">
                                                        <select id="asset_year" className='form-control' {...register("asset_year", { required: 'Asset year is required!' })}>
                                                            <option value="-1" >-- Select Year --</option>
                                                            {years.map((item, i) => <option key={`asset-year-${i}`} value={item} >{item}</option>)}
                                                        </select>
                                                        {errors.asset_year && <span className='text-danger'>{errors.asset_year.message}</span>}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="type_id" className="col-sm-2 col-form-label mandatory">Asset Type</label>
                                                    <div className="col-sm-10">
                                                        {pageState == 'add' && (<div>
                                                            <select id="type_id" className='form-control' {...register("type_id", { required: 'Asset type is required!' })} onChange={setChange}>
                                                                <option value="-1" >-- Select Asset Type --</option>
                                                                {types.map((item, i) => <option key={`asset-type-${i}`} value={item._id} >{item.type_name}</option>)}
                                                            </select>
                                                            {errors.type_id && <span className='text-danger'>{errors.type_id.message}</span>}
                                                        </div>
                                                        )}
                                                        {pageState != 'add' && (<div>
                                                            <input id="type_name" {...register("type_name")} className='form-control' readOnly={true} style={{ background: `#e9ecef`}} />
                                                            <input id="type_id" type="hidden" {...register("type_id")}/>
                                                            {errors.type_id && <span className='text-danger'>{errors.type_id.message}</span>}
                                                        </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="title" className="col-sm-2 col-form-label mandatory">Storage</label>
                                                    <div className="col-sm-10">
                                                        {pageState == 'add' && (<div>
                                                            <select id="function_id" className='form-control' {...register("function_id", { required: 'Asset function is required!' })} onChange={setChange}>
                                                                <option value="-1" >-- Select Function --</option>
                                                                {main_menus?.map((item, i) => <option key={`folder-${i}`} value={item._id} >{item.menu_name}</option>)}
                                                            </select>
                                                            {errors.function_id && <span className='text-danger'>{errors.function_id.message}</span>}
                                                        </div>
                                                        )}
                                                        {pageState != 'add' && (<div>
                                                            <input id="function_id" {...register("function_id")} type="hidden" />
                                                            <input id="function_name" {...register("function_name")} className='form-control' readOnly={true} style={{ background: `#e9ecef`}} />
                                                            {errors.folder && <span className='text-danger'>{errors.folder.message}</span>}
                                                        </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="title" className="col-sm-2 col-form-label mandatory">Category</label>
                                                    <div className="col-sm-10">
                                                        {pageState == 'add' && (<div>
                                                            <select id="category_id" className='form-control' {...register("category_id", { required: 'Asset category is required!' })} onChange={setChange}>
                                                                <option value="-1" >-- Select Category --</option>
                                                                {sub_menus?.map((item, i) => <option key={`category-${i}`} value={item._id} >{item.menu_name}</option>)}
                                                            </select>
                                                            {errors.category_id && <span className='text-danger'>{errors.category_id.message}</span>}
                                                        </div>
                                                        )}
                                                        {pageState != 'add' && (<div>
                                                            <input id="category_id" {...register("category_id")} type="hidden"/>
                                                            <input id="category_name" {...register("category_name")} className='form-control' readOnly={true} style={{ background: `#e9ecef`}} />
                                                            {errors.category && <span className='text-danger'>{errors.category.message}</span>}
                                                        </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="title" className="col-sm-2 col-form-label mandatory">Brand</label>
                                                    <div className="col-sm-10">
                                                        {pageState == 'add' && (<div>
                                                            <select id="brand" defaultValue={'-1'} className='form-control' {...register("brand", { required: 'Asset brand is required!' })}>
                                                                <option value="-1" >-- Select Brand --</option>
                                                                {brands?.map((item, i) => <option key={`brand-${i}`} value={item} >{item}</option>)}
                                                            </select>
                                                            {errors.brand && <span className='text-danger'>{errors.brand.message}</span>}
                                                        </div>
                                                        )}
                                                        {pageState != 'add' && (<div>
                                                            <input id="brand" {...register("brand")} className='form-control' readOnly={true} style={{ background: `#e9ecef`}} />
                                                            {errors.brand && <span className='text-danger'>{errors.brand.message}</span>}
                                                        </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="type" className="col-sm-2 col-form-label" style={{ paddingLeft: '24px' }}>Asset Files</label>
                                                    <div className="col-sm-10">
                                                        <div className="form-check" style={{ paddingBottom: '10px' }}>
                                                            <input className="form-check-input" type="checkbox" id="opt_single" checked={checked} disabled={pageState != 'add'} onChange={() => handleChange()} />
                                                            <label className="form-check-label" htmlFor="opt_single">Is single file?</label>
                                                        </div>
                                                        <div className="form-check" style={{ paddingBottom: '10px' }}>
                                                            <input className="form-check-input" type="checkbox" id="opt_active_file" checked={checkedFile} onChange={() => handleChangeFile()} />
                                                            <label className="form-check-label" htmlFor="opt_active_file">Is Active Standard?</label> <h6>* {meta.meta_table?.active_file_message}</h6>
                                                        </div>
                                                        <div className="form-check" style={{ paddingBottom: '10px' }}>
                                                            <input className="form-check-input" type="checkbox" id="opt_archive_trash" checked={checkedTrash} onChange={() => handleChangeTrash()} />
                                                            <label className="form-check-label" htmlFor="opt_archive_trash">Is Archive Trash Bin?</label> <h6>* {meta.meta_table?.archive_trash_message}</h6>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="thumbnail" className="form-label mandatory">Thumbnail</label>
                                                            <div className='form-control'>
                                                                <div style={{ display: `inline-flex`} } >
                                                                    {
                                                                        pageState != 'add' && 
                                                                        <div className='form-control' style={{ marginRight: 10 }}>
                                                                            <img src={preview_url} style={{ height: 64, objectFit: 'cover' }} />
                                                                        </div>
                                                                    }
                                                                    <div className='form-control' style={{ marginRight: 10 }}>
                                                                        <Uploader
                                                                            name="thumbnail"
                                                                            multiple={false}
                                                                            autoUpload={false}
                                                                            listType="picture"
                                                                            value={thumbnail}
                                                                            onChange={e => thumbnailUpload(e)}
                                                                            disabled={thumbnail == '' ? false : true}
                                                                            onRemove={e => thumbnailRemove(e)}
                                                                            action=''>
                                                                        </Uploader>
                                                                    </div>
                                                                </div>
                                                                <span style={{ color: 'darkgrey' }}>Resolusi: 1280 x 70 (min width 640 pixel), Format: JPG/PNG/GIF, Max: 500Kb</span>
                                                            </div>
                                                            {errors.thumbnail && <span className='text-danger'>{errors.thumbnail.message}</span>}
                                                        </div>


                                                        {checked && (<div className="mb-3">
                                                            <label htmlFor="file_single" className="form-label mandatory">File</label>
                                                            <div className='form-control'>
                                                                <Uploader
                                                                    name="file_single"
                                                                    multiple={true}
                                                                    autoUpload={false}
                                                                    listType="picture-text"
                                                                    defaultFileList={singleFileList}
                                                                    fileList={singleFileList}
                                                                    //value={file_single}
                                                                    onChange={e => fileUpload(e)}
                                                                    disabled={singleFileList.length >= stdMaxUpload ? true : false}
                                                                    onRemove={e => fileRemove(e)}
                                                                    action=''
                                                                    renderFileInfo={(file, fileElement) => {
                                                                        return (
                                                                            <><span>File Name : { file.name }</span></>
                                                                        );
                                                                      }}
                                                                    draggable>
                                                                    <div style={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'darkgrey' }}>
                                                                        <span>Drop File Here..</span>
                                                                    </div>
                                                                    
                                                                </Uploader>
                                                            </div>
                                                            {errors.file && <span className='text-danger'>{errors.file.message}</span>}
                                                        </div>
                                                        )}
                                                        {!checked && (<div>
                                                            <div className="mb-3">
                                                                <label htmlFor="high" className="form-label">High Size</label>
                                                                <div className='form-control'>
                                                                    <Uploader
                                                                        name="file_high"
                                                                        multiple={true}
                                                                        autoUpload={false}
                                                                        listType="picture-text"
                                                                        defaultFileList={highFileList}
                                                                        fileList={highFileList}
                                                                        removable={true}
                                                                        onChange={e => highUpload(e)}
                                                                        disabled={highFileList.length >= highMaxUpload ? true : false}
                                                                        onRemove={e => highRemove(e)}
                                                                        action=''
                                                                        renderFileInfo={(file, fileElement) => {
                                                                            return (
                                                                                <><span>File Name : { file.name }</span></>
                                                                            );
                                                                          }}
                                                                        draggable>
                                                                        <div style={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'darkgrey' }}>
                                                                            <span>Drop File Here..</span>
                                                                        </div>
                                                                    </Uploader>
                                                                </div>
                                                                {errors.file_high && <span className='text-danger'>{errors.file_high.message}</span>}
                                                            </div>

                                                            <div className="mb-3">
                                                                <label htmlFor="low" className="form-label">Low Size</label>
                                                                <div className='form-control'>
                                                                    <Uploader
                                                                        name="file_low"
                                                                        multiple={true}
                                                                        autoUpload={false}
                                                                        listType="picture-text"
                                                                        defaultFileList={lowFileList}
                                                                        fileList={lowFileList}
                                                                        //value={file_low}
                                                                        onChange={e => lowUpload(e)}
                                                                        disabled={lowFileList.length >= lowMaxUpload ? true : false}
                                                                        onRemove={e => lowRemove(e)}
                                                                        action=''
                                                                        renderFileInfo={(file, fileElement) => {
                                                                            return (
                                                                                <><span>File Name : { file.name }</span></>
                                                                            );
                                                                        }}
                                                                        draggable>
                                                                        <div style={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'darkgrey' }}>
                                                                            <span>Drop File Here..</span>
                                                                        </div>
                                                                    </Uploader>
                                                                </div>
                                                                {errors.file_low && <span className='text-danger'>{errors.file_low.message}</span>}
                                                            </div>

                                                            <div className="mb-3">
                                                                <label htmlFor="raw" className="form-label">Original File (PSD / CRD)</label>
                                                                <div className='form-control'>
                                                                    <Uploader
                                                                        name="file_raw"
                                                                        multiple={true}
                                                                        autoUpload={false}
                                                                        listType="picture-text"
                                                                        defaultFileList={rawFileList}
                                                                        fileList={rawFileList}
                                                                        //value={file_raw}:
                                                                        removable={true}
                                                                        onChange={e => rawUpload(e)}
                                                                        disabled={rawFileList.length >= rawMaxUpload ? true : false}
                                                                        onRemove={e => rawRemove(e)}
                                                                        action=''
                                                                        renderFileInfo={(file, fileElement) => {
                                                                            return (
                                                                                <><span>File Name : { file.name }</span></>
                                                                            );
                                                                        }}
                                                                        draggable>
                                                                        <div style={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'darkgrey' }}>
                                                                            <span>Drop File Here..</span>
                                                                        </div>
                                                                    </Uploader>
                                                                </div>
                                                                {errors.file_raw && <span className='text-danger'>{errors.file_raw.message}</span>}
                                                            </div>
                                                        </div>)}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="filter_id" className="col-sm-2 col-form-label mandatory">Filter search</label>
                                                    <div className="col-sm-10">
                                                        <select id="filter_id" className='form-control' {...register("filter_id", { required: 'Asset filter is required!' })} readOnly={pageState == 'edit'}>
                                                            <option value="-1" >-- Select Asset Filter --</option>)
                                                            {filters.map((item, i) => <option key={`asset-filter-${i}`} value={item._id} >{item.filter_name}</option>)}
                                                        </select>
                                                        {errors.filter_id && <span className='text-danger'>{errors.filter_id.message}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        pageState != 'view' &&
                                        <div className='card-footer'>
                                            <div className='row'>
                                                <div className='col-md-10'>
                                                    <div className='d-flex' style={{ justifyContent: 'flex-end' }}>
                                                        <button type='button' className='btn btn-outline-dark mr-3' style={{ width: 100 }} onClick={onBack}><i className='fa fa-reply' /> Back</button>
                                                        {
                                                            pageState == 'add' && <button type='button' className='btn btn-danger mr-3' style={{ width: 100 }} onClick={onReset}><i className='fa fa-times' /> Clear</button>
                                                        }
                                                        <button type='submit' className='btn btn-dark' style={{ width: 100 }} disabled={isnotvalid}><i className='fa fa-save' /> Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </form>
                            </div>
                        </div>
                    </div>
                </div >
            </section >
            <div style={{ height: 20 }} />
        </div>
    )
};

export default AssetDetailScreen;